export default __webpack_public_path__ + "static/media/Girdle of the Bloodmoon.b93665d1.jpg";